import { Field } from 'formik';
import React, { useEffect, useState } from 'react';
import { CustomInput, FormGroup, Input, Label } from 'reactstrap';
import { ButtonWithLoadingIcon } from '../../../components/common/ButtonWithLoadingIcon';
import { Colxx } from '../../../components/common/CustomBootstrap';
import { LinkButton } from '../../../components/common/LinkButton';
import { RentalReturnStep2 } from './returnStep2';

const FormRowScaffold = ({
  label,
  id,
  showError,
  error,
  children,
  fieldDescription = '',
  isSM,
  ...other
}) => {
  return (
    <FormGroup row style={{ marginBottom: isSM ? 20 : '1rem' }}>
      <Label
        for={id}
        md={3}
        {...other}
        style={{ fontFamily: 'Brown', paddingBottom: isSM ? 8 : null }}
      >
        {label}
      </Label>
      <Colxx md={9}>
        {children}
        {showError && (
          <div
            className='invalid-feedback d-block'
            style={{ fontFamily: 'Brown' }}
          >
            {error}
          </div>
        )}

        {fieldDescription && (
          <small className='text-muted mb-2 mt-2 d-block'>
            {fieldDescription}
          </small>
        )}
      </Colxx>
    </FormGroup>
  );
};

const CommonInputFormRow = ({
  label,
  name,
  id,
  type,
  showError,
  error,
  isSM,
  ...otherProps
}) => (
  <FormRowScaffold
    label={label}
    id={id}
    showError={showError}
    error={error}
    isSM={isSM}
  >
    <Field
      type={type}
      name={name}
      id={id}
      className='form-control'
      {...otherProps}
    />
  </FormRowScaffold>
);

export const RentalReturnStep3A = ({
  productList,
  onClickNext,
  onClickPrevious,
}) => {
  const data = [
    {
      id: 1,
      title: 'I live in an apartment complex',
      content:
        'If you live in an apartment complex that requires a key fob or code to access, please leave your return(s) in your leasing office and we will pick it up during business hours.',
    },
    {
      id: 2,
      title: 'I live in a house',
      content: `If you live in a house or residence that does not require security access, please leave your return(s) outside your front door and we will pick it up within your pickup window.`,
    },
    {
      id: 3,
      title: 'I live in on-campus',
      content: `If you live on-campus in an apartment or dorm, please use the time picker to book on available window that works with your schedule. We'll send you a text when we're on the way!`,
    },
  ];
  const [selectedLiveLocation, setSelectedLiveLocation] = useState(null);
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');
  const [phnNumber, setPhnNumber] = useState('');
  const [note, setNote] = useState('');
  const [dataList, setDataList] = useState(data);

  useEffect(() => {
    setDataList(data);
  }, []);

  const renderButton = () => {
    return (
      <div className={'review-button'}>
        <ButtonWithLoadingIcon
          style={{
            alignSelf: 'center',
            width: '35%',
            marginBottom: 10,
          }}
          type='submit'
          color={'primary'}
          onClick={() => {
            if (onClickNext) {
              onClickNext({
                selectedLiveLocation,
                date,
                time,
                phnNumber,
                note,
              });
            }
          }}
        >
          Next
        </ButtonWithLoadingIcon>
        <LinkButton
          className={'mt-3'}
          style={{
            marginBottom: 10,
            textAlign: 'center',
            width: '100%',
            height: 55,
            cursor: 'pointer',
          }}
          onClick={() => {
            if (onClickPrevious) {
              onClickPrevious({
                selectedLiveLocation,
                date,
                time,
                phnNumber,
                note,
              });
            }
          }}
        >
          Previous
        </LinkButton>
      </div>
    );
  };
  return (
    <div
      style={{
        marginLeft: '2.5rem',
        marginRight: '2.5rem',
      }}
    >
      <div style={{ marginBottom: 30 }}>
        <span style={{ marginBottom: 10 }}>Where do you live?</span>
        {dataList?.length > 0 ? (
          dataList?.map((d, index) => {
            return (
              <div
                style={{
                  marginBottom: index === dataList.length - 1 ? 0 : 15,
                }}
              >
                <div
                  className='d-flex list-view flex-direction-column'
                  style={
                    selectedLiveLocation?.title === d?.title
                      ? { backgroundColor: '#F5E5D9', flexDirection: 'column' }
                      : { flexDirection: 'column' }
                  }
                  area-disabled={d.isNotActive}
                  onClick={() => {
                    setSelectedLiveLocation(d);
                  }}
                >
                  <span
                    style={{ fontFamily: 'Brown', fontSize: 22 }}
                    className='mb-2'
                  >
                    {d.title || '--'}
                  </span>
                  <span style={{ fontFamily: 'Brown', fontSize: 16 }}>
                    {d.content || ''}
                  </span>
                </div>
              </div>
            );
          })
        ) : (
          <div className='d-flex align-items-center justify-content-center h-100'>
            No method found for return
          </div>
        )}
      </div>
      {selectedLiveLocation?.id === 1 ? null : (
        <div style={{ marginBottom: 30 }}>
          <span className='mb-1'>Choose your pickup window</span>
          <div className='d-flex align-items-center'>
            <Input
              id='exampleDate'
              name='date'
              placeholder='date placeholder'
              type='date'
              onChange={(value) => setDate(value)}
              style={{ marginRight: 15 }}
            />
            <Input
              id='exampleDate'
              name='date'
              placeholder='date placeholder'
              onChange={(value) => setTime(value)}
              type='time'
            />
          </div>
        </div>
      )}
      <div style={{ marginBottom: 30 }}>
        <span className='mb-1'>
          We'll text the following number with any updates or questions
          regarding your pickup
        </span>
        <Input
          id='phoneNumber'
          name='phoneNumber'
          placeholder='(207) 337-0157'
          type='text'
          onChange={(value) => setPhnNumber(value)}
        />
      </div>
      <div style={{ marginBottom: 30 }}>
        <span className='mb-1'>
          Anything else we should know for this pickup?
        </span>
        <Input
          id='note'
          name='note'
          type='textarea'
          onChange={(value) => setNote(value)}
        />
      </div>
      {renderButton()}
    </div>
  );
};
